import { NavigationItem } from './navigation.models'
import { AuthPage } from '@core/authentication/auth/auth.enums'

export const NAVIGATION_ITEMS: NavigationItem[] = [
  /*{
  name: 'Administration',
  icon: 'user',
  url: AuthPages.Administration,
  deactivated: environment.CURRENT_DEACTIVATED_PAGES[AuthPages.Administration]
}, */
  {
    name: 'MTR_TITLE_DATA_INCOMING',
    icon: 'dart-down-squared',
    url: AuthPage.DataIncoming,
  },
  {
    name: 'MTR_TITLE_DATA_PUBLISHING',
    icon: 'dart-up-squared',
    url: AuthPage.DataPublishing,
  },
  {
    name: 'MTR_TITLE_USER_CUSTOMER',
    icon: 'face',
    url: AuthPage.UserCustomerView,
  },
  {
    name: 'MTR_TITLE_PERMISSION_MANAGEMENT',
    icon: 'support',
    url: AuthPage.PermissionManagement,
  },
  {
    name: 'MTR_TITLE_MARKETABLE',
    icon: 'comercial',
    url: AuthPage.Marketable,
  },
  {
    name: 'MTR_TITLE_STADIUM',
    icon: 'stadium',
    url: AuthPage.Stadium,
  },
  {
    name: 'MTR_TITLE_STADIUMS',
    icon: 'stadium',
    url: AuthPage.Stadiums,
    deactivated: true,
  },
  {
    name: 'MTR_TITLE_PLAYERS_MANAGER',
    icon: 'players',
    url: AuthPage.PlayersManager,
  },
  {
    name: 'MTR_TITLE_MEDIA_REPORTS',
    icon: 'report',
    url: AuthPage.MediaReports,
  },
]
